import Http from '../http';

const prefix = '/elearning';

var softCache = [];

export const getCourses = () => {
  if (!softCache['get-courses'])
    softCache['get-courses'] = Http.authApi().get(`${prefix}/courses`);

  return softCache['get-courses'];
};



// WEBPACK FOOTER //
// ./src/js/services/integrations-internas/elearming.js